export function storeUtm() {
  const qs = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: qs.get("utm_source") || "",
    utm_medium: qs.get("utm_medium") || "",
    utm_campaign: qs.get("utm_campaign") || "",
    utm_content: qs.get("utm_content") || "",
    utm_term: qs.get("utm_term") || "",
    utm_id: qs.get("utm_id") || "",
  };
  localStorage.setItem("utm", JSON.stringify(utm));
}

export function getUtm() {
  return safeJsonParse(localStorage.getItem("utm"));
}

export function safeJsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
}
function preloadImage(image, callback) {
  return new Promise((resolve) => {
    var img = new Image();
    img.src = image;
    img.onload = () => {
      resolve();
      if (callback) callback(...arguments);
    };
  });
}
export function preloadImages(images, callback) {
  return new Promise(async (resolve) => {
    await images.map(async (image) => {
      await preloadImage(image, callback);
    });
    resolve();
  });
}
